/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PeriodoRendicontazioneCreationForm } from '../model/models';
import { PeriodoRendicontazioneDTO } from '../model/models';
import { RendicontazioneEsercenteDTO } from '../model/models';
import { RendicontazioneNotaForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AccettaRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
    nota?: string;
    controfirmata?: Blob;
}

export interface ChiudiPeriodoRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idPeriodo: string;
}

export interface DownloadFileRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
    controfirmata?: boolean;
}

export interface DownloadNotaDebitoRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
}

export interface GeneraPeriodoRendicontazioneManualeRequestParams {
    idTipoPratica: string;
    periodoRendicontazioneCreationForm: PeriodoRendicontazioneCreationForm;
}

export interface GetRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
}

export interface ListPeriodiRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
}

export interface ListRendicontazioniPeriodoBackofficeRequestParams {
    idTipoPratica: string;
    idPeriodo: string;
}

export interface PagataRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
    rendicontazioneNotaForm?: RendicontazioneNotaForm;
}

export interface RifiutaRendicontazioneBackofficeRequestParams {
    idTipoPratica: string;
    idRendicontazione: string;
    rendicontazioneNotaForm?: RendicontazioneNotaForm;
}


export interface GestioneRendicontazioneEsercentiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Accetta una rendicontazione (backoffice), con controfirmata opzionale.
     * Multipart: part \&#39;controfirmata\&#39; (file opzionale) + part \&#39;nota\&#39; (JSON opzionale). {SOTTOMESSA, RIFIUTATA} → ACCETTATA.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/accetta
* @param requestParameters
     */
    accettaRendicontazioneBackoffice(requestParameters: AccettaRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

    /**
     * Chiusura amministrativa di un periodo (backoffice). ABILITATO → DISABILITATO.
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/{id_periodo}/chiudi
* @param requestParameters
     */
    chiudiPeriodoRendicontazioneBackoffice(requestParameters: ChiudiPeriodoRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PeriodoRendicontazioneDTO>;

    /**
     * Scarica il file nota firmata / controfirmata caricato (backoffice).
     * ?controfirmata&#x3D;true per la controfirmata. File non valorizzato → 404.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/file
* @param requestParameters
     */
    downloadFileRendicontazioneBackoffice(requestParameters: DownloadFileRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Scarica il PDF nota di debito di una rendicontazione (backoffice).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/nota-debito
* @param requestParameters
     */
    downloadNotaDebitoRendicontazioneBackoffice(requestParameters: DownloadNotaDebitoRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Genera manualmente un periodo di rendicontazione su un intervallo esplicito (SUPERADMIN).
     * Innescabile SOLO da SUPERADMIN (matcher dedicato in SecurityConfigApi, dichiarato PRIMA del catch-all SUPERADMIN|OP_COMUNE|OP_PRATICA_ESERCENTE della famiglia rendicontazioni). Il cron mensile non rigenera/sovrascrive un periodo già coperto: se l\&#39;intervallo si sovrappone a un periodo su cui esiste già un invio esercente (status diverso da DA_SOTTOMETTERE), l\&#39;operazione è rifiutata (422): per rigenerare, rifiutare prima la rendicontazione. Il compute gira su tutti gli esercenti ABILITATI del bando (il periodo è del bando, non di un singolo negozio).
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/genera
* @param requestParameters
     */
    generaPeriodoRendicontazioneManuale(requestParameters: GeneraPeriodoRendicontazioneManualeRequestParams, extraHttpRequestParams?: any): Observable<PeriodoRendicontazioneDTO>;

    /**
     * Dettaglio di una rendicontazione esercente (backoffice).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}
* @param requestParameters
     */
    getRendicontazioneBackoffice(requestParameters: GetRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

    /**
     * Periodi di rendicontazione di un bando (backoffice).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi
* @param requestParameters
     */
    listPeriodiRendicontazioneBackoffice(requestParameters: ListPeriodiRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<PeriodoRendicontazioneDTO>>;

    /**
     * Rendicontazioni di un periodo (una per esercente abilitato), ricalcolate.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/{id_periodo}
* @param requestParameters
     */
    listRendicontazioniPeriodoBackoffice(requestParameters: ListRendicontazioniPeriodoBackofficeRequestParams, extraHttpRequestParams?: any): Observable<Array<RendicontazioneEsercenteDTO>>;

    /**
     * Segna pagata una rendicontazione dopo il bonifico (backoffice). ACCETTATA → PAGATA.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/pagata
* @param requestParameters
     */
    pagataRendicontazioneBackoffice(requestParameters: PagataRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

    /**
     * Rifiuta una rendicontazione (backoffice). SOTTOMESSA → RIFIUTATA.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/rifiuta
* @param requestParameters
     */
    rifiutaRendicontazioneBackoffice(requestParameters: RifiutaRendicontazioneBackofficeRequestParams, extraHttpRequestParams?: any): Observable<RendicontazioneEsercenteDTO>;

}
